import { PackageTypeId } from "./enum";

export enum ProjectMailOrderConditionIfType {
    Amount = 1,
    Article = 2,
}

export enum ProjectMailOrderConditionAddType {
    Postage = 1,
    Article = 2,
}

export enum ProjectMailOrderConditionIfOperator {
    LessThan = 1,
    MoreThan = 2,
    Equals = 3,
    NotEquals = 4,
    LessThanOrEqual = 5,
    MoreThanOrEqual = 6,
}

export interface ProjectMailOrderConditionDto {
    id: number;
    ifType: ProjectMailOrderConditionIfType;
    ifOperator: ProjectMailOrderConditionIfOperator;
    ifAmount: number;
    ifQuantity: number;
    ifSaleArticleDetailId: number | null;
    ifSaleArticleId: number | null;
    ifDeliveryMethodPlaceSpecified: boolean | null;
    ifLanguage: string;
    ifCallCenterId: number | null;
    addType: ProjectMailOrderConditionAddType;
    addDisc: number;
    addQuantity: number;
    displayGroup: string;
    displayGroupPosition: number;
    positionInDisplayGroup: number;
    selectionGroup: string;
    addSaleArticleDetailId: number | null;
    addSaleArticleId: number | null;
    addArticle: null | {
        saleArticleId: number;
        price: number;
        baseQuantity: number;
        code: string;
        name: string;
        weight: number;
        isPost: boolean;
        packageType: PackageTypeId | null;
    },
}
